import { userContext } from '../userManager';

/* Advisor */

export const apiAdvisorClientsGet = (advisorId) =>
  userContext.apiCall({ url: `/financialadvisors/${advisorId}/clients` });

export const apiAdvisorInviteLinkPost = (id) =>
  userContext.apiCall({ url: `/financialadvisors/${id}/invitation-links`, method: 'POST' });
